import VideosWrapper from '../assets/wrappers/Videos'
import React from 'react'
// import { useGlobalContext } from '../context'
import { FaYoutube } from 'react-icons/fa'
// var Spinner = require('react-spinkit')
import { SingleVideo } from '../components/SingleVideo'

export const Videos = () => {
  const urls = [
    // 2025
    'https://www.youtube.com/embed/shnUlIhMa2w',
    //end 2025
    'https://www.youtube.com/embed/p1-vr6-r17M?si=REp-Joup-70vdC5v',
    'https://www.youtube.com/embed/mOQD_TsQO40?si=TZkIKMxR8r0J_Am7',
    'https://www.youtube.com/embed/1ecn1FRCFW0?si=GFd2H_BxvSDj5mBp',
    // new
    'https://www.youtube.com/embed/qXZ2C8AR8Wc',
    'https://www.youtube.com/embed/-wCln8jjjio',
    'https://www.youtube.com/embed/QmRfJibyoQo',
    'https://www.youtube.com/embed/T4zEVFG5e7Q',
    'https://www.youtube.com/embed/z5LAOW7Y6NM',
    'https://www.youtube.com/embed/tPLU0Edj9i0',
    'https://www.youtube.com/embed/T-Ujte2HSGQ',
    'https://www.youtube.com/embed/CcBAz3deRHk',
    'https://www.youtube.com/embed/lbSv6_Wm47c',
    // end newly added
    'https://www.youtube.com/embed/vgKpUWM1eks',
    'https://www.youtube.com/embed/8emW5vsF66g',
    'https://www.youtube.com/embed/Vh9IWnKmU2k',
    'https://www.youtube.com/embed/rXd0UtpLi20',
    'https://www.youtube.com/embed/VgPbiaWAEbo',
    'https://www.youtube.com/embed/sXSEowvjTkg',
    'https://www.youtube.com/embed/7Sllr05EvLA',
    'https://www.youtube.com/embed/EfsQbXHkEEM',
    'https://www.youtube.com/embed/PI82mGt2qm8',
    'https://www.youtube.com/embed/-RCOjJ9At2o',
    'https://www.youtube.com/embed/-RCOjJ9At2o',
  ]
  // const { loading, videos } = useGlobalContext()
  // if (loading) {
  //   return (
  //     <section className='videos-section'>
  //       <div className='section-center initial-section'>
  //         <div className='loading'>
  //           <h1>Loading...</h1>
  //         </div>
  //       </div>
  //     </section>
  //   )
  // }

  return (
    <section className='main videos-section'>
      <div className='section-center initial-section'>
        <div className='btn-container'>
          <a
            href='https://www.youtube.com/channel/UCzb3-4iGZDOQooVYAcYsZdg'
            target='_blank'
            rel='noreferrer'
            className='btn'
            // className='btn banner-btn youtube-btn'
          >
            <FaYoutube style={{ marginRight: '1rem' }} />
            youtube
          </a>
        </div>
        <VideosWrapper>
          {/* <div className='videos-grid'> */}
          {urls.map((url, index) => {
            return <SingleVideo url={url} key={index} />
          })}
          {/* </div> */}
        </VideosWrapper>
      </div>
    </section>
  )
}
